import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import './Layout.scss';
import SideNav from './SideNav';
interface childrenProps {
 
}
const Layout: React.FC<childrenProps> = (props) => { 
  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <div className='container is-fluid'>
      <div className='efl-main-sidenav'>
        <SideNav isOpen={isOpen} />
      </div>
      <div className={`efl-main-header ${isOpen ? "expanded" : ""}`}>
        <Header setIsOpen={(value)=>setIsOpen(value)} isOpen={isOpen} />
      </div>
      <div className={`efl-main-div ${isOpen ? "expanded" : ""}`} >        
         <Outlet />
      </div>
    </div>
  )
}

export default Layout
